import { UserGroupIcon } from '@heroicons/react/24/outline';
import { Box, Chip, Group, Title } from '@mantine/core';

interface CVRolesSectionProps {
  roles: string[];
}

export function CVRolesSection({ roles }: CVRolesSectionProps) {
  if (!roles || roles.length === 0) {
    return null;
  }

  return (
    <Box>
      <Title order={5} mb="xs" style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
        <UserGroupIcon style={{ width: 16, height: 16 }} />
        Role Overview
      </Title>
      <Box my="md">
        <Group gap={8}>
          {roles.map((role, index) => (
            <Chip
              key={index}
              checked={false}
              variant="filled"
              color="teal"
              size="xs"
              radius="sm"
            >
              {role}
            </Chip>
          ))}
        </Group>
      </Box>
    </Box>
  );
}

